// Taşeron portalı — Belgeler sayfasının "Belge Analizi" giriş düğmesi (S25 kenar çubuğu
// hiyerarşisi §13, sahip geri bildirimi: "Add a button next to 'Belge Yukle' to go analysis.
// Add a badge to show the number of analysis awaiting."). `AppLayout.tsx`'in Belge Analizi'ne
// kasıtlı olarak bir kenar çubuğu girişi TAŞIMAMASının (S19-D12) tek telafisi — kuyruk boşken
// ve hiçbir yükleme/analiz UÇUŞTA değilken `/document-analysis`'e giden BAŞKA HİÇBİR yol yoktur
// (§11.1), bu yüzden bu düğme sıfırda da GİZLENMEZ (§13.4) — arşiv de bu yolun ARKASINDA yaşar.
//
// **Varyant `secondary`, ASLA `primary`.** `DocumentsPage.tsx`'in "bu sayfadaki TEK turuncu
// öğe, her durumda" yorumu bu düğmenin varyantını da belirler — burayı `primary` yapmak o
// kuralı bozar; bu düğmenin `Belge Yükle`'ye HER ZAMAN kaybetmesi gerekir.
//
// **Rozet belge sayar, analiz DEĞİL (§13.3).** `countDecisions` burada KULLANILAMAZ — o, analiz
// BAŞINA bir `detail` çekimi ister ve Belgeler sayfası hiçbir detay çekmez (`StrandedAnalysesStrip`
// yalnız sıkışan adaylar için çeker). `items[].pendingItemCount` TOPLAMI aynı sorgudan
// (`PendingAnalysesStrip`'in KULLANDIĞI, `pageSize` verilmeyen AYNI anahtar — TanStack
// tekilleştirir, EK istek YOK) gelir ve rayın daraltılmış sayımıyla, şeridin satır sayılarıyla
// AYNI birimi (belge) konuşur.
//
// **`{{count}}+`, sunucu sayfalaması bu sorguyu (varsayılan 50) kestiğinde.** `filteredTotal`
// süzgeç SONRASI toplam analiz sayısıdır; `items.length` ondan azsa toplam bir ALT SINIRdır,
// asla kesin sayı gibi gösterilmez (rayın kendi `truncatedNotice`'ının AYNI dürüstlüğü, §13.3).
//
// **Asla `0` gösterilmez.** Yükleniyor/hata → sayı BİLİNMİYOR, rozet OMİTİLİR — rayın daraltılmış
// sayımı için §5.6'nın koyduğu kuralın AYNISI: bilinmeyen bir sayı asla sıfır gibi gösterilmez,
// çünkü bir an sonra `8` olacak bir `0` "bu özellik hiçbir şey üretmedi" gibi okunur (yanlış).
//
// Rozet `bg-bg` dolgulu — düğmenin dinlenme (`bg-surface`, 1.22:1) ve üstüne gelme
// (`bg-surface-muted`, 1.36:1) dolgularının İKİSİNDEN de ayrışan tek nötr fill, aynı §2'nin 1.
// seviye bandı için seçtiği metafor (sayfa zemini bir yüzeyi delip geçiyor). Stok `Badge`
// KULLANILMAZ: `tone="neutral"`in `bg-surface-muted` dolgusu düğmenin ÜSTÜNE gelme dolgusuyla
// AYNI — rozet imlecin altında 1.00:1'e düşüp KAYBOLURDU (§17).

import { Button, cn } from '@isgportal/shared';
import { FileSearch } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDocumentAnalysisList } from '../lib/useDocumentAnalysis';

export function AnalysisInboxButton() {
  const { t } = useTranslation();
  const { items, filteredTotal, isPending, error } = useDocumentAnalysisList('awaiting-review');
  // Yükleniyor ya da hata → sayı BİLİNMİYOR; asla `0` gösterilmez (§13.4).
  const pending =
    isPending || error !== null ? null : items.reduce((n, a) => n + a.pendingItemCount, 0);
  const truncated = filteredTotal > items.length;

  return (
    <Button asChild variant="secondary">
      <Link to="/document-analysis">
        <FileSearch className="h-4 w-4" aria-hidden="true" />
        {t('analysis.title')}
        {pending !== null && pending > 0 ? (
          <>
            <span
              aria-hidden="true"
              className={cn(
                'inline-flex min-w-[1.5rem] shrink-0 items-center justify-center rounded-full',
                'border border-border-strong bg-bg px-1.5 py-0.5 text-xs font-medium tnum text-fg',
              )}
            >
              {truncated ? t('documents.analysisInbox.badgeAtLeast', { count: pending }) : pending}
            </span>
            <span className="sr-only">
              {truncated
                ? t('documents.analysisInbox.pendingSrAtLeast', { count: pending })
                : t('documents.analysisInbox.pendingSr', { count: pending })}
            </span>
          </>
        ) : null}
      </Link>
    </Button>
  );
}
